module.exports = __webpack_public_path__ + "img/Bild1.572d90c6.jpg";